define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var AppConfig       = require('config/application');
    /*
     *	Модель профиля пользователя/сотрудника
     */
    return Backbone.Model.extend({
        defaults: function () {
            return {
                avatar: "/img/icon/contacts-person.png",
                profile_type: 1,
                job: 'Менеджер',
                calls_to_mobile: true,
                profile_access: false,
                employee_access: false,
                employee_access_edit: false,
                access_projects_create: false,
                access_projects_edit: false,
                balance: false,
                notify_lead_sms: true,
                notify_lead_email: true,
                notify_deal_sms: true,
                notify_deal_email: true,
                notify_missed_calls_sms: true,
                notify_missed_calls_email: true,
                phones: true,
                block_if_has_reminder: true,
                show_lptracker_number: false,
                show_card_on_calls: true,
                worklog_view_allow: false,
                timezone: 2,
                schedule_work_1: true,
                schedule_work_2: true,
                schedule_work_3: true,
                schedule_work_4: true,
                schedule_work_5: true,
                schedule_work_6: true,
                schedule_work_7: true,
                start_time_1: '00:00',
                start_time_2: '00:00',
                start_time_3: '00:00',
                start_time_4: '00:00',
                start_time_5: '00:00',
                start_time_6: '00:00',
                start_time_7: '00:00',
                end_time_1: '23:59',
                end_time_2: '23:59',
                end_time_3: '23:59',
                end_time_4: '23:59',
                end_time_5: '23:59',
                end_time_6: '23:59',
                end_time_7: '23:59',
                schedule_start: '00:00',
                schedule_end: '23:59',
                general_start_time: '00:00',
                general_end_time: '23:59',
                notify_enabled: true,
                notify_type: 'both',
                notify_interval: 1,
                notify_start: 'time',
                notify_end: 1,
                conversion_notify_sms: true,
                conversion_notify_email: true,
                conversion_notify_popup: true,
                conversion_notify_client: true,
                conversion_notify_client_template: 'Спасибо за обращение в нашу компанию. Ваш персональный менеджер {manager}, {manager_phone}',
                sip_login: '',
                sip_password: '',
                first_day_date: app.Utils.moment().format('DD.MM.YYYY'),
                work_days_count: 2,
                relax_days_count: 2,
                show_phone: false,
                settings_access: true,
                referral_access: true,
                telegram: '',
                max_notify: '',
            };
        },
        urlRoot: function () {
            if (this.get('profile_type') == 0) {
                return AppConfig.host + '/rest/users';
            } else {
                return AppConfig.host + '/rest/employees';
            }
        },
        initialize: function () {

        },
        parse: function (response) {
            if (response.result !== undefined) {
                return response.result.data;
            } else {
                return response;
            }
        }
    });
});
